import React from "react";

// プレーン文字列を表示用 React ノードに変換する軽量整形ヘルパー。
//   - **強調** → <b>強調</b>
//   - 改行 \n → <br/>
export function renderWord(text: string): React.ReactNode {
  return text.split("\n").map((line, li) => (
    <React.Fragment key={li}>
      {li > 0 && <br />}
      {renderEmphasis(line)}
    </React.Fragment>
  ));
}

function renderEmphasis(line: string): React.ReactNode {
  return line.split("**").map((part, i) =>
    i % 2 === 1 ? <b key={i}>{part}</b> : <React.Fragment key={i}>{part}</React.Fragment>
  );
}
